<!-- 我要对接的弹框 -->
<template>
  <div class="Docking">
    <el-dialog
      :title="ParentId==0?'立即对接':'评论'"
      :visible.sync="DialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <!-- 输入框 -->
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="textarea"
        maxlength="1000"
        show-word-limit
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Dialogoff">取 消</el-button>
        <el-button type="primary" @click="Dialogon">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Filter, docking } from '../api/url'
import { postAction } from '../api/api'
import { number } from 'echarts'
export default {
  props: {
    DialogVisible: { type: Boolean },
    id: { type: String },
    type: { required: true, type: String },
    ParentId: { require: this, type: number },
  },
  components: {},
  data() {
    return {
      DialogVisible: this.DialogVisible,
      textarea: '',
      UserID: '',
      projectid: this.id,
    }
  },
  computed: {},
  watch: {
    DialogVisible: function (nval, oval) {
      // console.log(nval, oval);
    },
    projectid: function (nval1, oval1) {
      // console.log("对接的projectID",nval1, oval1);
    },
  },
  methods: {
    handleClose() {
      this.DialogVisible = false
      this.$emit('update:DialogVisible', false)
      //  // console.log("点击了x")
    },
    Dialogoff() {
      this.DialogVisible = false
      this.$emit('update:DialogVisible', false)
      //  // console.log("点击了取消")
    },
    Dialogon() {
      this.$emit('update:DialogVisible', false)
      //  // console.log("输入的内容",this.textarea)
      //  // console.log("点击了确定")
      //  我要对接敏感词过滤
      this.Filterwords()
    },
    Filterwords() {
      let data = {
        action: 'Filter_Words',
        Words: this.textarea,
      }
      postAction(Filter, this.$qs.stringify(data)).then((res) => {
        if (res == 0) {
          // console.log("过滤敏感词返回的", res, "留言内容正常");
          // 留言内容正常之后可以发我要对接的请求了
          this.docking()
        } else {
          this.$message({
            message: '留言内容不规范,请重新输入',
            type: 'warning',
          })

          this.textarea = ''
        }
      })
    },

    docking() {
      this.UserID = localStorage.getItem('RealID')
      if (this.type == 4 || this.type == 5) {
        // console.log('类型是4或者5')
        let data = {
          action: 'Add',
          userid: this.UserID,
          projectid: this.projectid,
          type: this.type,
          content: this.textarea,
          ParentId: this.ParentId,
        }
        // 我要留言对接
        postAction(docking, this.$qs.stringify(data)).then((res) => {
          // // console.log("我要留言对接返回的",res)
          // this.$message(res.msg);

          this.DialogVisible = false
          this.$message({
            message: res.msg,
            type: 'success',
          })
        })
      } else {
        let data = {
          action: 'Add',
          sort: 'DESC',
          userid: this.UserID,
          projectid: this.projectid,
          type: this.type,
          content: this.textarea,
          ParentId: this.ParentId,
        }
        // 我要留言对接
        postAction(docking, this.$qs.stringify(data)).then((res) => {
          // // console.log("我要留言对接返回的",res)
          // this.$message(res.msg);

          this.DialogVisible = false
          this.$message({
            message: res.msg,
            type: 'success',
          })
        })
      }
    },
  },
  created() {
    // console.log("docking", this.DialogVisible);
    this.UserID = localStorage.getItem('RealID')
    // console.log('成果厅详情type',this.type)
    // console.log('成果厅详情pjid',this.id)
  },
  mounted() {},
}
</script>
<style lang='scss' scoped>
/deep/ .el-textarea__inner {
  min-height: 12.5rem !important;
}
</style>